import _classCallCheck from "/Users/phil/Workspace/petroff-billing-master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/phil/Workspace/petroff-billing-master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
var PaymentTypes = {
  1: "Cash",
  2: "Credit",
  3: "Check",
  0: "None"
};
var InvoiceTypeImpl = /*#__PURE__*/function () {
  function InvoiceTypeImpl() {
    _classCallCheck(this, InvoiceTypeImpl);
    this.LOAD = 'loadInvoices';
    this.SHOP = 'shopInvoices';
    this.TOW = 'towInvoices';
  }
  _createClass(InvoiceTypeImpl, [{
    key: "getInvoicesPart",
    value: function getInvoicesPart(invoiceType) {
      if (invoiceType === this.LOAD) {
        return 'loadinvoices';
      } else if (invoiceType === this.SHOP) {
        return 'shopinvoices';
      } else {
        return 'invoices';
      }
    }
  }, {
    key: "getInvoicePart",
    value: function getInvoicePart(invoiceType) {
      if (invoiceType === this.LOAD) {
        return 'loadinvoice';
      } else if (invoiceType === this.SHOP) {
        return 'shopinvoice';
      } else {
        return 'invoice';
      }
    }
  }, {
    key: "editInvoicesPart",
    value: function editInvoicesPart(invoiceType) {
      if (invoiceType === this.LOAD) {
        return 'editLoadInvoice';
      } else if (invoiceType === this.SHOP) {
        return 'editShopInvoice';
      } else {
        return 'editInvoice';
      }
    }
  }, {
    key: "isShopInvoices",
    value: function isShopInvoices(invoiceType) {
      return invoiceType === this.SHOP;
    }
  }, {
    key: "plainString",
    value: function plainString(invoiceType) {
      if (invoiceType === this.LOAD) {
        return "Load";
      } else if (invoiceType === this.SHOP) {
        return "Shop";
      } else {
        return "Tow";
      }
    }
  }, {
    key: "getInvoicePrefix",
    value: function getInvoicePrefix(invoiceType) {
      if (invoiceType === this.LOAD) {
        return 'L';
      } else if (invoiceType === this.SHOP) {
        return 'S';
      } else {
        return 'T';
      }
    }
  }, {
    key: "getNumberForInvoice",
    value: function getNumberForInvoice(invoiceType, invoice) {
      if (invoiceType === this.TOW) {
        return invoice.number;
      } else {
        return invoice.id;
      }
    }
  }, {
    key: "actionDateString",
    value: function actionDateString(invoiceType) {
      if (invoiceType === this.TOW) {
        return "Date Towed";
      } else {
        return "Date";
      }
    }
  }, {
    key: "actionKey",
    value: function actionKey(invoiceType) {
      if (invoiceType === this.TOW) {
        return "dateTowed";
      } else {
        return "date";
      }
    }
  }, {
    key: "invoiceIdKey",
    value: function invoiceIdKey(invoiceType) {
      if (invoiceType === this.TOW) {
        return "number";
      } else {
        return "id";
      }
    }
  }]);
  return InvoiceTypeImpl;
}();
var InvoiceType = new InvoiceTypeImpl();
export { PaymentTypes, InvoiceType };